import React from "react";
import { makeStyles } from "tss-react/mui";
const useStyles = makeStyles()((theme) => ({
  container: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(2)
  }
}));
function Form({ children, onSubmit }) {
  const { classes } = useStyles();
  return /* @__PURE__ */ React.createElement("form", { onSubmit, className: classes.container }, children);
}
export {
  Form
};
//# sourceMappingURL=Form.js.map
